module.exports = __webpack_public_path__ + "img/igape-on.d28b3c3c.png";